import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

interface BootstrapDialogProps {
  customWidth?: string;
}

const BootstrapDialog = styled(Dialog)<BootstrapDialogProps>(
  ({ theme, customWidth }) => ({
    "& .MuiDialogContent-root": {
      padding: "0px 24px 16px 24px",
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
    "& .MuiPaper-root": {
      borderRadius: "8px",
      // height: "500px",
      maxHeight: "max-content",
      width: customWidth || "708px", // Use custom width or default to 708px
      maxWidth: "none", // Prevents Material-UI from overriding your width
    },
  })
);

export default BootstrapDialog;
